module.exports = __webpack_public_path__ + "static/media/menu.b5b397b5.svg";